
define('template!ordersDetailSupplierView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="body">\n  <div class="body-content">\n    <div class="left">\n       <div class="invoice-region"></div>\n    </div>\n    <div class="right">\n      <div class="product-region"></div>\n    </div>\n  </div>\n  <div class="empty">' +
((__t = ( _.i18n('order.detail.supplier.empty') )) == null ? '' : __t) +
'</div>\n  <div class="loader-ctn">\n    <div class="loader-2"></div>\n  </div>\n</div>\n<div class="buttons">\n  <div class="edit-button-region"></div>\n</div>';

}
return __p
};});

